import { FormInputDropdown } from 'app/components/Candidate/CandidateProfile/CandidateTabPanel/PersonalInfoTab/Form/Controls/FormInputDropdown';
import { getSearchFilterOptions } from 'app/services/SharedServices/SharedServices';
import { orderBy } from 'lodash';
import React, { useEffect, useState } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { usePromiseTracker } from 'react-promise-tracker';
import { useSelector } from 'react-redux';
import { selectIsEditMod } from 'store/redux-store/placement-mods/selectors';
import { findKeyBaseOnValue, formatTypeAheadOptions } from '../../ModificationsUtils';

export const PayableTo = () => {
  const { control, getValues, setValue, register, clearErrors, setError } = useFormContext();
  const { t } = useTranslation();
  const namePayableTo = 'payableTo';
  register('payeeId');
  const { promiseInProgress: isSaveModApiCalling } = usePromiseTracker({ area: 'save-mod-api', delay: 0 });
  const isModEdit = useSelector(selectIsEditMod);
  const [payeeOptions, setPayeeOptions] = useState([]);

  const getPayeeDropDown = async () => {
    const options = await getSearchFilterOptions('payee');

    if (options?.length > 0) {
      const newOptions = formatTypeAheadOptions(options);
      setPayeeOptions(orderBy(newOptions, 'id', 'asc'));

      if (getValues(namePayableTo)) {
        const selectedOption = findKeyBaseOnValue(newOptions, getValues(namePayableTo));
        setValue('payeeId', selectedOption?.id);
        clearErrors(namePayableTo);
      } else {
        setError(namePayableTo, {});
      }
    }
  };

  const getPayeeId = (value: string) => {
    const selectedOption = findKeyBaseOnValue(payeeOptions, value);
    return selectedOption?.id;
  };

  const onSelectionChange = (value: string) => {
    setValue(namePayableTo, value);
    setValue('payeeId', getPayeeId(value));
    if (value) {
      clearErrors(namePayableTo);
    }
  };

  useEffect(() => {
    getPayeeDropDown();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Controller
      control={control}
      name={namePayableTo}
      rules={{
        required: true,
      }}
      render={({ field: { onChange, value, ...rest } }) => (
        <FormInputDropdown
          useMenuItem={true}
          name={namePayableTo}
          label={t('placement.placementMods.payableTo')}
          require={false}
          standard={true}
          options={payeeOptions ?? []}
          handleChange={e => {
            onSelectionChange(e.target.value);
            onChange(e.target.value);
          }}
          inputValue={getValues(namePayableTo) ?? ''}
          readOnly={!isModEdit}
          disabled={isSaveModApiCalling}
          {...rest}
        ></FormInputDropdown>
      )}
    />
  );
};
